import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api';

export function useAdminStats(month?: string, status?: string) {
  return useQuery({
    queryKey: ['admin', 'stats', month, status],
    queryFn: async () => {
      const { data } = await adminApi.getStats(month, status);
      return data.stats;
    },
  });
}
